module.exports = __webpack_public_path__ + "static/img/mobile_member_banner.f148f395.png";